<!-- https://github.com/greyby/vue-spinner/blob/master/src/MoonLoader.vue -->
<template>
  <div class="v-spinner">
    <div class="v-moon v-moon1">
      <div class="v-moon v-moon2"></div>
      <div class="v-moon v-moon3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .v-spinner {
    .v-moon1 {
      position: relative;
      animation: v-moonStretchDelay 0.6s 0s infinite linear;
      animation-fill-mode: forwards;
      height: 1em;
      width: 1em;
    }
    .v-moon2 {
      position: absolute;
      background-color: currentColor;
      opacity: 0.8;
      top: 0.5em;
      width: 0.15em;
      height: 0.15em;
      border-radius: 100%;
      animation: v-moonStretchDelay 0.6s 0s infinite linear;
      animation-fill-mode: forwards;
    }
    .v-moon3 {
      border: 0.15em solid currentColor;
      width: 1em;
      height: 1em;
      opacity: 0.2;
      border-radius: 100%;
    }
  }

  @-webkit-keyframes v-moonStretchDelay {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes v-moonStretchDelay {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
